import React, { useState, useContext } from 'react';
import { Activities, attraqtTracker } from '../../../../analytics/attraqt/attraqtTracker';
import { ListerContext } from '../../listerContext';
import Facet from './facet';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import { FacetData, FacetValueData } from '../../../../types';
import useListerApi from '../../listerApiHooks';
import mediaQuery from '../../../../helpers/mediaQuery';

const { isFacetSwatchesEnabled, facetIconSwatches, facetColourSwatches, facetFilters, plpPriceSliderStyle } =
  window.globalLister;

interface FacetContainerProps {
  facet: FacetData;
}

function FacetContainer({ facet }: FacetContainerProps): React.ReactElement {
  const facetExpanded = mediaQuery.isSmallOnly() ? false : facet.expanded;
  const [isExpanded, setIsExpanded] = useState(facetExpanded);
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ isListerDisabled, breadcrumbs, rid }] = useContext(ListerContext);
  const { selectFacet } = useListerApi();

  const togglerHandler = (): void => {
    setIsExpanded((expanded) => !expanded);
  };

  const facetSelectionHandler = (facetValue: FacetValueData, facetData: FacetData): void => {
    if (!facetValue.selected && !facetData.priceFacet) {
      attraqtTracker({
        action: Activities.CLICK,
        target: { facet: facetData.facetId, [facetData.facetId]: facetValue.name },
        sourceId: rid
      });
    }

    selectFacet(facetValue.selected ? getRemoveQuery(facetValue.code) : facetValue.query.location);

    function getRemoveQuery(code: string): string {
      return breadcrumbs.find(({ facetValueCode }) => facetValueCode === code)?.removeQuery.location || '';
    }
  };

  return (
    <Facet
      facet={facet}
      breadcrumbs={breadcrumbs}
      isExpanded={isExpanded}
      isDisabled={isListerDisabled}
      isIconsEnabled={
        isFacetSwatchesEnabled && facetIconSwatches.map((facetCode) => facetCode.toLowerCase()).includes(facet.code)
      }
      isColoursEnabled={
        isFacetSwatchesEnabled && facetColourSwatches.map((facetCode) => facetCode.toLowerCase()).includes(facet.code)
      }
      isFilterEnabled={facetFilters.includes(facet.code)}
      facetTogglerHandler={togglerHandler}
      facetSelectionHandler={facetSelectionHandler}
      plpPriceSliderStyle={plpPriceSliderStyle}
      messages={{
        placeholder: formattedMessage({
          id: 'search.nav.facets.search.placeholder',
          values: { 0: facet.name.toLowerCase() },
          fallback: `Search for ${facet.name.toLowerCase()}`
        }),
        noResults: formattedMessage({
          id: 'search.nav.facets.search.noResults',
          values: { 0: facet.name.toLowerCase() },
          fallback: `Sorry, no ${facet.name.toLowerCase()}s found.`
        })
      }}
    />
  );
}

export default FacetContainer;
